export default __webpack_public_path__ + "static/media/orderIconClicked.07417e07.svg";